import { RecordObject } from 'src/models/general.model';

export function toRecordObject<T = undefined>(data: unknown): RecordObject<T> {
  return data as RecordObject<T>;
}

export function toType<T = undefined>(data: unknown): T {
  return data as T;
}
